import React from 'react';
import { Box, Typography, useTheme, useMediaQuery, Container, Tooltip } from "@mui/material";
import { styled } from "@mui/system";

const BadgesShowcase = () => {
    const theme = useTheme();
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");

    // Badge descriptions
    const descriptions = {
        "verified": "Earned after email verification",
        "supporter": "Kofi supporters who help Uben grow",
        "partner": "Official partners of the Uben platform",
        "developer": "Developers of the platform",
        "helper": "Active community helpers and moderators",
        "contributor": "Users contributing to community resources",
        "special": "Special badge for special people",
    };

    // Animation for badge hover
    const BadgeImage = styled('img')(() => {
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    return {
        width: isNonMobileScreens ? '3.5rem' : '3rem',
        height: isNonMobileScreens ? '3.5rem' : '3rem',
        objectFit: 'contain',
        transition: 'transform 0.3s ease',
        filter: 'drop-shadow(0 0 8px rgba(255, 255, 255, 0.3))',
        marginBottom: isNonMobileScreens ? '0' : '0.1rem',
        '&:hover': {
            transform: isNonMobileScreens ? 'scale(1.1)' : 'scale(1.05)',
            filter: 'drop-shadow(0 0 12px rgba(255, 255, 255, 0.5))',
        },
    };
});
    
const BadgeContainer = styled(Box)(({ theme }) => {
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    return {
        borderRadius: isNonMobileScreens ? "10px" : "8px",
        padding: isNonMobileScreens ? "1.5rem" : "1rem",
        // backgroundColor: isNonMobileScreens ? "rgba(100, 146, 216, 0.6)" : "rgba(35, 38, 40, 0.75)",
        backdropFilter: "blur(10px)",
        boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: isNonMobileScreens ? "1rem" : "0.6rem",
        width: isNonMobileScreens ? "200px" : "110px",
        maxWidth: isNonMobileScreens ? "230px" : "140px",
        margin: isNonMobileScreens ? "0" : "0.25rem",
        transition: "transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out",
        "&:hover": {
            transform: isNonMobileScreens ? "translateY(-5px)" : "none",
            boxShadow: isNonMobileScreens ? "0 10px 30px rgba(0, 0, 0, 0.2)" : "0 4px 20px rgba(0, 0, 0, 0.25)",
        },
    };
});    return (
        <Box
            width="auto"
            maxWidth={isNonMobileScreens ? "90%" : "100%"}
            display="flex"
            flexDirection="column"
            gap={isNonMobileScreens ? "2rem" : "1rem"}
            justifyContent="center"
            alignItems="center"
            textAlign="center"
            sx={{
                backdropFilter: "blur(10px)",
                boxShadow: "0 8px 32px rgba(31, 38, 135, 0.2)",
                borderRadius: isNonMobileScreens ? "1rem" : "0.5rem",
                border: "1px solid rgba(45, 129, 255, 0.18)",
                padding: isNonMobileScreens ? "3rem" : "1.5rem 0.75rem",
                margin: isNonMobileScreens ? "3rem auto" : "1.5rem auto",
            }}
        >
            <Typography
                variant={isNonMobileScreens ? "h4" : "h5"}
                color="white"
                fontWeight="bold"
                sx={{
                    textShadow: `0 2px 2px ${theme.palette.grey[700]}`,
                    marginBottom: isNonMobileScreens ? "0" : "0.5rem",
                }}
            >
                Community Badges
            </Typography>
            <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                gap={isNonMobileScreens ? "2rem" : "1rem"}
                width={isNonMobileScreens ? "100%" : "100%"}
                sx={{
                    flexWrap: "wrap",
                    paddingX: isNonMobileScreens ? "1rem" : "0.5rem"
                }}
            >
                {Object.keys(descriptions).map((badge) => (
                    <BadgeContainer
                        key={badge}
                    >
                        <Tooltip 
                            title={
                                <Typography color="inherit">{descriptions[badge]}</Typography>
                            }
                            placement="top"
                            arrow
                            enterTouchDelay={0}
                            leaveTouchDelay={1500}
                        >
                            <BadgeImage 
                                src={`/assets/badges/${badge}.svg`} 
                                alt={`${badge} badge`}
                            />
                        </Tooltip>
                        <Typography
                            color="white"
                            fontWeight="600"
                            textTransform="capitalize"
                            fontSize={isNonMobileScreens ? "1rem" : "0.82rem"}
                            sx={{ 
                                wordBreak: "keep-all",
                                letterSpacing: isNonMobileScreens ? "0.5px" : "0.2px",
                                textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                                lineHeight: "1.2",
                                width: "100%",
                                textAlign: "center"
                            }}
                        >
                            {badge}
                        </Typography>
                    </BadgeContainer>
                ))}
            </Box>
        </Box>
    );
};

export default BadgesShowcase;
